import React, { FC, useEffect, useState } from "react";
import NcImage from "shared/NcImage/NcImage";
import i18n from 'i18next';
import languageIcon from "images/icon/lang.svg";
import { Menu, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useTranslation } from "react-i18next";

export interface ComponentProps { }

const ChangeLang: FC<ComponentProps> = () => {
	const { t } = useTranslation();
	const items: MenuProps['items'] = [
		{ key: 'zh-HK', label: '繁體中文' },
		{ key: 'zh-CN', label: '简体中文' },
		{ key: 'en', label: 'English' }
	];

	const onChangeLanguage = (e: any) => {
		localStorage.setItem('language', e.key);
		i18n.changeLanguage(e.key).then(() => {
			window.location.reload();
		});
	}

	useEffect(() => {

	}, []);

	return (
		<Dropdown menu={{ items, onClick: onChangeLanguage }} placement="bottom">
			<button type="button" aria-label={t('common.change_language')} className="flex h-11 w-11 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-primary-500">
				<NcImage className="h-auto w-7" src={languageIcon} alt="" />
			</button>
		</Dropdown>
	);
};

export default ChangeLang;
